import { render } from "./InformationSection.vue?vue&type=template&id=7ad04910&scoped=true"
import script from "./InformationSection.vue?vue&type=script&lang=js"
export * from "./InformationSection.vue?vue&type=script&lang=js"

import "./InformationSection.vue?vue&type=style&index=0&id=7ad04910&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad04910"]])

export default __exports__